import React from 'react';
import './projectArtwork.css';

export default function ProjectArtwork({ project }) {
  return (
    <div className="project-artwork">
      <img src={project.cover} alt={`${project.title} project preview`} loading="lazy" decoding="async" />
    </div>
  );
}
